/* ============================================================
   PebbleBloom - Benefit Cards
   File: assets/pb-benefit-cards.js

   Lights one card at a time on a cycle.

   Purely additive: the cards render and read correctly with no
   script. Nothing here hides content.
   ============================================================ */

(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(grid) {
    if (grid.dataset.pbShineInit === '1') return;
    grid.dataset.pbShineInit = '1';
    if (reduced) return;

    var cards = grid.querySelectorAll('.pb-bc__card');
    if (cards.length < 2) return;

    var gap = (parseFloat(grid.dataset.pbShineInterval) || 3) * 1000;
    var i = -1;
    var timer = null;

    function tick() {
      // A hidden tab throttles timers, so on return every queued
      // tick fires at once and the whole grid flashes. Skipping
      // while hidden keeps the cycle one-at-a-time.
      if (document.hidden) return;

      i = (i + 1) % cards.length;
      var card = cards[i];
      card.classList.add('is-shining');
      setTimeout(function () {
        card.classList.remove('is-shining');
      }, 1000);
    }

    function run() {
      if (timer) return;
      timer = setInterval(tick, gap);
    }

    function stop() {
      clearInterval(timer);
      timer = null;
    }

    // Only cycle while the grid is actually on screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) run();
            else stop();
          });
        },
        { threshold: 0.2 }
      ).observe(grid);
    } else {
      run();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else run();
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-pb-shine]'), start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  /* pb-atf.js mirrors this grid into the buy box and re-builds that
     copy whenever a section re-renders. The copy is created after the
     events above have fired, so it announces itself here. */
  document.addEventListener('pb:content-changed', function (e) {
    init(e.detail && e.detail.scope);
  });
})();
